module.exports = __webpack_public_path__ + "img/logo_jia_blue.ddc99768.png";